export enum MessageCategory {
    Info = 'Info',
    Warning = 'Warning',
    Alert = 'Alert',
}
